import last from "lodash/last";
import type { FunctionComponent } from "react";
import { useRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { entityFollowMenuQueueItemsEdge$key } from "~/queries/__generated__/entityFollowMenuQueueItemsEdge.graphql";

import { Container, MenuItemsContainer, StyledEntityLink, StyledRightArrowIcon } from "./styles";

type Props = {
  onClick?: (itemLabel: string) => void;
  reference: entityFollowMenuQueueItemsEdge$key;
};

export const EntityFollowMenu: FunctionComponent<Props> = ({ onClick, reference }) => {
  const items = useFragment(
    graphql`
      fragment entityFollowMenuQueueItemsEdge on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Topic {
            name
          }
          ... on Section {
            name
          }
          ...entityLink
        }
      }
    `,
    reference,
  );

  const menuItemsReference = useRef<HTMLDivElement>(null);

  const handleRightArrowIconClick = () => {
    if (menuItemsReference.current) {
      menuItemsReference.current.scrollLeft += menuItemsReference.current.clientWidth;
    }
  };

  const cleanUpLabel = (string_?: string) => {
    const label = last(string_?.split(":") ?? []) ?? "";
    return label.trim();
  };

  return (
    <Container>
      <MenuItemsContainer ref={menuItemsReference}>
        {items.map(({ node }, index) => (
          <StyledEntityLink
            key={index}
            reference={node}
            onClick={() => {
              onClick?.(cleanUpLabel(node.name));
            }}
          >
            {cleanUpLabel(node.name)}
          </StyledEntityLink>
        ))}
      </MenuItemsContainer>
      <StyledRightArrowIcon onClick={handleRightArrowIconClick} />
    </Container>
  );
};

EntityFollowMenu.displayName = "EntityFollowMenu";
